
import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-slate-950 text-white">
      {/* Footer Content */}
      <div
        className="
          mx-auto
          grid
          max-w-7xl
          grid-cols-1
          gap-10
          px-5
          py-14
          sm:grid-cols-2
          lg:grid-cols-4
          lg:gap-12
          lg:px-8
        "
      >
        {/* Brand */}
        <div>
          <Link to="/" className="inline-block">
            <img
              src="/logo512.png"
              alt="SERVICE IPTV Logo"
              className="h-14 w-auto object-contain"
            />
          </Link>

          <h3 className="mt-4 text-xl font-bold text-white">
            SERVICE
          </h3>

          <p className="mt-4 max-w-sm text-sm leading-6 text-gray-400">
            SERVICE IPTV France - Accès illimité à plus de 10,000 chaînes
            de télévision en direct et contenu à la demande en haute
            définition.
          </p>
        </div>

        {/* Explore */}
        <div>
          <h4 className="mb-5 text-sm font-semibold uppercase tracking-wider text-white">
            Explore
          </h4>

          <ul className="space-y-3">
            <li>
              <Link
                to="/"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                Accueil
              </Link>
            </li>

            <li>
              <Link
                to="/pricing"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                Pricing
              </Link>
            </li>
          </ul>
        </div>

        {/* Help */}
        <div>
          <h4 className="mb-5 text-sm font-semibold uppercase tracking-wider text-white">
            Help
          </h4>

          <ul className="space-y-3">
            <li>
              <Link
                to="/About"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                About
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="mb-5 text-sm font-semibold uppercase tracking-wider text-white">
            Legal
          </h4>

          <ul className="space-y-3">
            <li>
              <Link
                to="/privacy-policy"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link
                to="/terms"
                className="
                  text-sm text-gray-400
                  transition-colors duration-200
                  hover:text-blue-400
                "
              >
                Terms of Service
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div
          className="
            mx-auto
            flex
            max-w-7xl
            flex-col
            items-center
            justify-center
            gap-2
            px-5
            py-6
            text-center
            sm:px-8
          "
        >
          <p className="flex flex-wrap items-center justify-center gap-1 text-sm text-gray-500">
            <span>© {currentYear} SERVICE IPTV France.</span>

            <span>Fait avec</span>

            <Heart
              size={16}
              className="fill-current text-red-500"
            />

            <span>par l'équipe SERVICE IPTV</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

